<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="internalDate"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :outlined="outlined"
        :value="formattedDate"
        :label="label"
        :dense="dense"
        :prepend-icon="showIcon ? 'mdi-calendar' : ''"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="internalDate"
      :max="max"
      no-title
      scrollable
      @input="saveDate"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DatePickerDate",
  props: {
    // La fecha inicial que recibe del componente padre
    value: {
      type: String,
      default: () => new Date().toISOString().substr(0, 10), // Fecha actual
    },
    label: {
      type: String,
      default: () => "Fecha",
    },
    // Fecha máxima seleccionable, en formato "YYYY-MM-DD"
    max: {
      type: String,
      default: undefined,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    formattedDate() {
      // Formatea la fecha interna usando Moment.js
      return this.internalDate
        ? this.moment(this.internalDate).format("LL") // Ajusta el formato según tus necesidades
        : "";
    },
  },
  data() {
    return {
      internalDate: this.value, // Fecha manejada internamente
      menu: false,
    };
  },
  watch: {
    // Cuando la prop cambia en el padre, actualiza el valor interno
    value(newVal) {
      this.internalDate = newVal;
    },
  },
  methods: {
    saveDate() {
      this.$refs.menu.save(this.internalDate);
      this.menu = false;
      // Emitir el cambio al componente padre
      this.$emit("input", this.internalDate);
    },
  },
};
</script>
